exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".environment-config .otc-password-icon {\n  top: 17px;\n  position: absolute !important;\n  margin-right: 17px;\n  right: 0;\n  cursor: pointer; }\n\n.environment-config .otc-anywhere-section {\n  display: flex; }\n\n.environment-config .w-95 {\n  width: 95px !important; }\n\n.environment-config .w-12 {\n  width: 12%; }\n\n.environment-config .header-section {\n  margin-top: 15px;\n  font-size: 17px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/tnt_control/component/environment_config/create/environment_config.create.scss
// module id = 1146
// module chunks = 1